import { useState, useEffect } from 'react';
import { useJob } from '../../state/jobs';
import { Loading } from '../loading';
import { Controls } from './Controls';
import { Results } from './Results';
import { Progress } from './Progress';
import { TimesChartForJobs } from '../job/Progress';
import { DisplayPrompt } from './DisplayPrompt';
import { NagToPay } from '../level';
import { styles } from './shared';
import { headerHeight } from '../../constants';
import { Button } from '../input';
import { SummaryTitle } from '../title';

export const AgentJob = ({ jobId }) => {
  const { job } = useJob(jobId);

  return (
    <div>
      <SummaryTitle
        summaryKey={job?.id && `jobId:${job.id}`}
        object={{ prompt: job?.params?.prompt, params: job?.params?.params }}
        fallback="Agent"
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ position: 'sticky', top: 6 + headerHeight, zIndex: 100 }}>
          <NagToPay />
        </div>
        <Controls job={job} />
        {job?.agentId && <Button to={`/agents/run/${job.agentId}`}>Run Again</Button>}
        <Results job={job} />

        {/*
        <pre>{JSON.stringify(job, null, 2)}</pre>
            <pre>{JSON.stringify(children, null, 2)}</pre>
        <Progress job={job} />
        <TimesChartForJobs jobs={children} />
          */}
      </div>
    </div>
  );
};
